import React from 'react';
import Link from 'next/link';

type HeadProps = {
  country: string;
  countryIsoAlpha02: string;
};

const Head = ({ country, countryIsoAlpha02 }: HeadProps) => {
  return (
    <section className="freight-forwarder-landing__head">

      <div className="container">
        <div className="freight-forwarder-landing__head-image-box">
          <img
            className="freight-forwarder-landing__head-image"
            src='/images/pages/Resources/FreightForwarder/landings/head-image.png'
            alt='image'
          />
        </div>
        <div className="freight-forwarder-landing__head-content">

          <div className="freight-forwarder-landing__head-description-box">
            <h1 className='freight-forwarder-landing__head-title'>
              {vectorHead}
              <span>Freight Forwarder</span>
              <span>in <span className='freight-forwarder-landing__head-country-box'>
                {country}
                  <i className={`freight-forwarder-landing__head-flag flag-icon flag-icon-${countryIsoAlpha02}`} />
              </span></span>
            </h1>
            <p className='freight-forwarder-landing__head-text'>
              Learn how to grow your freight forwarding business in {country} with DF Alliance.
            </p>

            <div className='new-header-hero__links-box'>
              <Link className='new-link-block full' href='/membership'>
                Get Membership Now
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

const vectorHead = (
  <svg xmlns="http://www.w3.org/2000/svg" width="127" height="126" viewBox="0 0 127 126" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M79.4664 41.2217C92.785 43.697 105.917 48.7262 114.555 58.3421C117.728 61.8745 119.793 66.0679 121.946 70.3344C122.135 70.7094 121.994 71.1446 121.631 71.3032C121.269 71.4629 120.819 71.2887 120.631 70.9147C118.543 66.7774 116.558 62.7017 113.485 59.28C104.977 49.8084 91.9785 44.9622 78.8528 42.5887C78.8079 42.6911 78.7641 42.7945 78.7204 42.898C77.759 45.1723 75.0451 47.2498 71.5867 48.8598C66.5674 51.1982 60.0001 52.6025 55.4113 52.4706C53.2945 52.4107 51.5742 52.004 50.5379 51.2815C49.6738 50.6803 49.2047 49.8755 49.2154 48.8594C49.2259 48.0215 49.5293 47.2274 50.092 46.4921C50.8435 45.5111 52.0755 44.6219 53.6269 43.8533C59.3673 41.0092 69.5413 39.7402 73.8561 40.3243C75.2079 40.5071 76.563 40.7138 77.9213 40.9468C78.2116 40.3059 78.487 39.6922 78.6924 39.0796C78.9938 38.1803 79.1414 37.2908 78.8938 36.3153C78.4377 34.5147 77.187 33.1012 75.6114 31.9703C73.0898 30.1582 69.7434 29.0668 67.1517 28.3931C52.5752 24.6035 39.1978 29.2792 27.9819 36.0525C16.6383 42.9017 7.49582 51.9092 1.53973 56.69C1.23274 56.9353 0.762634 56.8714 0.49196 56.546C0.219996 56.2221 0.248573 55.7579 0.554423 55.5116C6.54346 50.7051 15.7402 41.6583 27.1415 34.7731C38.6705 27.812 52.4379 23.0703 67.4217 26.9653C70.1783 27.6835 73.7325 28.8678 76.4171 30.7949C78.3137 32.1591 79.7812 33.891 80.3305 36.0587C80.6508 37.3227 80.4927 38.4813 80.104 39.642C79.9297 40.1624 79.7069 40.6861 79.4664 41.2217ZM77.3097 42.3209C76.4141 44.329 73.9369 46.0873 70.8747 47.5129C66.0516 49.76 59.7475 51.1207 55.3381 50.9953C53.8607 50.9524 52.609 50.7503 51.7328 50.3288C51.0989 50.025 50.6917 49.6044 50.6993 48.9912C50.7078 48.2858 51.0631 47.6468 51.6365 47.0508C52.2964 46.3633 53.2416 45.7435 54.37 45.1856C59.8753 42.458 69.632 41.2267 73.7685 41.7873C74.9456 41.9474 76.1276 42.125 77.3097 42.3209Z" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M121.355 72.7915C121.541 72.5195 121.697 72.0983 121.848 71.6438C122.191 70.6158 122.439 69.4077 122.578 68.8406C122.674 68.4533 123.074 68.2393 123.473 68.365C123.872 68.4908 124.116 68.9078 124.021 69.2962C123.851 69.9883 123.521 71.5894 123.065 72.7436C122.831 73.3366 122.549 73.8201 122.261 74.0886C121.977 74.3504 121.676 74.4228 121.374 74.391C121.056 74.3574 120.691 74.1706 120.32 73.7991C119.912 73.3907 119.43 72.7027 118.814 72.0366C118.299 71.4774 117.68 70.9245 116.892 70.661C116.495 70.529 116.255 70.109 116.359 69.7232C116.461 69.3387 116.866 69.1316 117.261 69.2649C118.741 69.7574 119.81 70.9634 120.617 71.9571C120.857 72.2533 121.174 72.5997 121.355 72.7915Z" fill="white"/>
  </svg>
);
export default Head;
